<template>
  <div class="sticky">
    <div class="sticky-wrapper">
      <template>
        <figure class="sticky-picture">
          <img :src="banner.picture" :alt="banner.title" />
          <a :href="banner.link" class="sticky-picture-link" target="_blank">
            <span class="u-visually-hidden">{{ banner.title }}</span>
          </a>
        </figure>
        <button class="sticky-close" @click="close">
          <sprite :type="'close'" :width="15" :height="15" />
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/components/Sprite.vue';

export default {
  components: {
    Sprite,
  },
  mounted() {
    this.$emit('mounted');
  },
  computed: {
    banner() {
      return this.$store.state.banner.item;
    },
  },
  methods: {
    close() {
      this.$store.commit('banner/closeBanner');
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky {
  @include size(100%, auto);
  position: relative;
  z-index: 1001;
  background-color: $white;

  &-wrapper {
    position: relative;
    @include margin(null auto);
    display: flex;
    width: 100%;
    max-width: 640px;
  }

  &-picture {
    width: 100%;
    background-color: $black;

    img {
      display: block;
      width: 100%;
    }

    &-link {
      @include size(100%);
      @include position(absolute, 0 null null 0);
      z-index: 2;
    }
  }

  // Close
  // -----------------------------------------------------------------------------
  &-close {
    @include position(absolute, 5px 5px null null);
    @include size(27px);
    z-index: 2;
    background-color: $primary;
    border-radius: 5px;
    outline: none;

    .svg {
      @include position(absolute, 50% null null 50%);
      transform: translate(-50%, -50%);
      fill: white;
    }
  }
}
</style>
